
    import './styles.scoped.css';
    export default {
  "navigation": "awsui_navigation_2p2ab_l7hg5_149",
  "is-navigation-open": "awsui_is-navigation-open_2p2ab_l7hg5_167",
  "animated-content": "awsui_animated-content_2p2ab_l7hg5_171",
  "hide-navigation": "awsui_hide-navigation_2p2ab_l7hg5_181"
};
  